import { render, staticRenderFns } from "./instructionFolder.vue?vue&type=template&id=328ae720"
import script from "./instructionFolder.vue?vue&type=script&lang=js"
export * from "./instructionFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports